import * as React from "react";
const TopArrow = (props) => (
 <svg
  width={42}
  height={30}
  viewBox="0 0 42 38"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...props}
 >
  <path
   d="M12.25 29.75L29.75 12.25"
   stroke="white"
   strokeWidth={2}
   strokeLinecap="round"
   strokeLinejoin="round"
  />
  <path
   d="M12.25 12.25H29.75V29.75"
   stroke="white"
   strokeWidth={2}
   strokeLinecap="round"
   strokeLinejoin="round"
  />
 </svg>
);
export default TopArrow;
